import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import styles from './Breedsimulator.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../Auth';
import { useAxios } from '../../../../AxiosHandler';
import PageTable from '../../../Shared/PageTable/PageTable';
import { general } from '../../../../general';
import Field from '../../../Shared/Wizard/Field/Field';
import Modal from '../../../Shared/Modal/Modal';
import OffspringDisplay from './OffspringDisplay/OffspringDisplay';

function Breedsimulator(props: BreedsimulatorProps) {
    const t = useTranslate();
    const navigate = useNavigate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const params = useParams();

    const [loading, setLoading] = useState<boolean>(false);

    const [showTraitsModal, setShowTraitsModal] = React.useState<boolean>(false);

    const [selectedDogId, setSelectedDogId] = useState<string | undefined>(params["dogid"]);
    const [selectedDog, setSelectedDog] = useState<any | undefined>(undefined);

    const [selectedDogs, setSelectedDogs] = useState<any[]>([]);

    const [totalDogs, setTotalDogs] = React.useState<number | undefined>(undefined);

    const [availableTraits, setAvailableTraits] = React.useState<any[]>(auth.availableBreeds?.find(i => i["ID"] == auth.selectedBreed)?.TRAITS ?? []);
    const [selectedTraits, setSelectedTraits] = React.useState<string[]>(JSON.parse(localStorage.getItem("dogs.selectedTraits." + auth.selectedBreed) ?? "[]"));

    const [specialFiltersOpen, setSpecialFiltersOpen] = React.useState<boolean>(false);
    const [specialfiltersfield, setSpecialfiltersfield] = React.useState<string>("");
    const [specialfiltersfrom, setSpecialfiltersfrom] = React.useState<string>("");
    const [specialfiltersto, setSpecialfiltersto] = React.useState<string>("");

    const [specialfilters, setSpecialfilters] = React.useState<any[]>(JSON.parse(localStorage.getItem("dogs.breedingsim.specialfilters." + auth.selectedBreed) ?? "[]"));

    const [resetFiltersTrigger, setResetFiltersTrigger] = React.useState<number>(0);

    const [showOnlyBreedingdogs, setShowOnlyBreedingdogs] = React.useState<boolean>(localStorage.getItem("dogs.showOnlyBreedingdogs") == "true" ? true : false);
    const [showOnlyApproveddogs, setShowOnlyApproveddogs] = React.useState<boolean>(localStorage.getItem("dogs.showOnlyApproveddogs") == "true" ? true : false);


    const [results, setResults] = useState<any[]>([]);

    function simulateBreeding(dogId: string, partnerIds: Array<string>) {
        setLoading(true);
        axios.single({
			method: 'post',
			url: "/api/dogs/simulatebreeding",
			responseType: 'json',
			data: {
                dogId: dogId,
                partnerIds: partnerIds
			},
			headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
		})
		.then((res) => {
            if (res.data != null && res.data.length > 0 && res.data[0] != null) {
                setResults(res.data);
            } else {
                alert(t("breedsimulator.errors.nodata"));
            }
            setLoading(false);
		}).catch((err) => {
            console.log(err);
            setLoading(false);
		});
    }

    function getDog(dogId: string | undefined = selectedDogId) {
        if (dogId == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/dogs/" + dogId,
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setSelectedDog(res.data);
        }).catch((err) => {
            console.log(err);
        });
    }

    // This is the same as in Dogs. Could be made into a global function?
    function createTraitColumn(trait: any) {
        if (trait != undefined) {
            let column: any = {
                label: t("dogs.table." + trait["NAME"]),
                field: trait["COLUMNDBNAME"],
            };
            column["override"] = (dataLine: any) => {
                if(trait["COLUMNDBNAME"].includes("_EBV")){
                    let accColumnDBName = trait["COLUMNDBNAME"].slice(0, trait["COLUMNDBNAME"].length -4)+"_ACC";
                    let accValue = dataLine[accColumnDBName];
                    let color = "#e1e855";
    
                    if (accValue > 0.6) {
                        color = "#68DB5A"; // Green
                    } else if (accValue > 0.3) {
                        color =  "#e1e855"; // Yellow
                    } else {
                        color =  "#e16a6a"; // Red
                    }
                    return <span
                        style={{
                            color: color,
                            fontWeight: 'bold'
                        }}
                    > 
                        {dataLine[trait["COLUMNDBNAME"]]}
                    </span>
                }else{
                    return dataLine[trait["COLUMNDBNAME"]];
                }
            }
            if (trait.DATATYPE == "datetime") {
                column["override"] = (dataLine: any) => {
                    if (dataLine[trait["COLUMNDBNAME"]] == null) {
                        return "";
                    }
                    let date = new Date(dataLine[trait["COLUMNDBNAME"]]);
                    return date.toLocaleDateString("nb-NO", { month: "2-digit", day: "2-digit", year: "numeric" })
                };
            }
            if (trait.OPTIONS != null) {
                column["customFilters"] = [
                    ...trait.OPTIONS.split(",").map((option: any) => {
                        // Remove spaces
                        let optionLabel = option?.replace(/\s/g, '') ?? "null";
                        return {
                            label: t("dogs.table.customfilteroptions." + optionLabel),
                            value: option
                        }
                    })
                ];
                column["override"] = (dataLine: any) => {
                    // Remove spaces
                    let labelOverride = dataLine[trait["COLUMNDBNAME"]]?.replace(/\s/g, '') ?? "null";
                    return t("dogs.table.customfilteroptions." + labelOverride);
                };
            }
            return column;
        } else {
            return undefined;
        }
    }


    function createSelectedTraitColumns() {
        if (selectedTraits.length == 0 || availableTraits.length == 0) {
            return [];
        }
        let columns: any[] = [];
        selectedTraits.forEach((trait: string) => {
            columns.push(createTraitColumn(availableTraits.find(i => i["COLUMNDBNAME"].split("|")[0] == trait)));
        });
        return columns;
    }

    function resetFilters() {
        setSpecialfilters([]);
        setSpecialfiltersfield("");
        setSpecialfiltersfrom("");
        setSpecialfiltersto("");
        
        setResetFiltersTrigger(resetFiltersTrigger + 1);

        setShowOnlyApproveddogs(false);
        localStorage.setItem("dogs.showOnlyApproveddogs", JSON.stringify(false));
        setShowOnlyBreedingdogs(false);
        localStorage.setItem("dogs.showOnlyBreedingdogs", JSON.stringify(false));
    }

    useEffect(() => {
        if (selectedTraits.length == 0) {
            setSelectedTraits([
                "NAME",
                "REGNO",
                "SEX",
                "POSTAL_CODE",
                "DATE_BIRTH",
            ]);
            
        }
    }, [auth.availableBreeds, auth.selectedBreed, selectedTraits]);

    // useEffect(() => {
    //     if (selectedDogs.length > 0 && selectedDogId != undefined) {
    //         simulateBreeding(selectedDogId, selectedDogs.map((dog: any) => dog["ANIMAL_ID"]));
    //     }
    // }, [selectedDogs]);

    useEffect(() => {
        setSelectedDogId(params["dogid"]);
        if (params["dogid"] != undefined && auth.selectedCountry != undefined) {
            getDog(params["dogid"]);
        }
    }, [auth.selectedCountry]);

    useEffect(() => {
        if (selectedDog?.ANIMAL_ID != undefined) {
            setAvailableTraits([
                ...(auth.availableBreeds?.find(i => i["ID"] == auth.selectedBreed)?.TRAITS ?? [])
            ]);
            setSelectedTraits(JSON.parse(localStorage.getItem("dogs.selectedTraits." + auth.selectedBreed) ?? "[]"));
        }
    }, [auth.availableBreeds, auth.selectedBreed, selectedDog]);

    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            localStorage.setItem("dogs.breedingsim.specialfilters." + auth.selectedBreed, JSON.stringify(specialfilters));
        }
    }, [specialfilters]);
    
    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            setSpecialfilters(JSON.parse(localStorage.getItem("dogs.breedingsim.specialfilters." + auth.selectedBreed) ?? "[]"));
        }
    }, [auth.selectedBreed]);

    return (
        <div className="maincontent">
            <div className={styles.breedsimulator}>
                <h1>{t("breedsimulator.title")} {selectedDog?.NAME ?? "Laster inn .."} | {selectedDog?.REGNO}</h1>
                <hr/>
                <div className={styles.topbuttons}>
                    <button className="btn btn-primary" onClick={() => {
                        if (results?.length > 0) {
                            setResults([]);
                        } else {
                            navigate("/hunder/" + selectedDogId);
                        }
                    }}>{t("dog.buttons.back")}</button>
                    { results?.length == 0 ?
                        <button
                            className="btn btn-primary"
                            disabled={selectedDogs.length == 0 || selectedDogId == undefined}
                            onClick={() => {
                                if (selectedDogs.length > 0 && selectedDogId != undefined) {
                                    simulateBreeding(selectedDogId, selectedDogs.map((dog: any) => dog["ANIMAL_ID"]));
                                }
                            }}
                        >{t("breedsimulator.buttons.startbreeding")}</button>
                    : null }
                    { results?.length > 0 ?
                        <button className="btn btn-primary" onClick={() => {
                            window.print();
                        }}>{t("breedsimulator.buttons.print")}</button>
                    : null }
                </div>
                <hr/>
                { results?.length == 0 ?
                    <>
                        <div className={styles.selecteddogs}>
                            <p>
                                {t("breedsimulator.selectdogsbelow")}
                            </p>
                            <button
                                className="btn btn-primary"
                                disabled={selectedDogs.length == 0 || selectedDogId == undefined}
                                onClick={() => {
                                    setSelectedDogs([]);
                                }}
                            >{t("breedsimulator.buttons.clearselecteddogs")}</button>
                        </div>
                        <hr/>
                    </>
                : null }
                { results?.length > 0 ?
                    null
                :
                    <div className={styles.dogscardheader}>
                        <div>
                            <div
                                className={styles.showonlybreedingdogsbtn}
                                onClick={() => {
                                    setShowOnlyApproveddogs(!showOnlyApproveddogs);
                                    localStorage.setItem("dogs.showOnlyApproveddogs", JSON.stringify(!showOnlyApproveddogs));
                                }}
                            >
                                { showOnlyApproveddogs ?
                                    <>
                                        <p>{t("dogs.showonlyapproveddogs")}</p>
                                        <i className="far fa-check-square"></i>
                                    </>
                                :
                                    <>
                                        <p>{t("dogs.showonlyapproveddogs")}</p>
                                        <i className="far fa-square"></i>
                                    </>
                                }
                            </div>
                            <div
                                className={styles.showonlybreedingdogsbtn}
                                onClick={() => {
                                    setShowOnlyBreedingdogs(!showOnlyBreedingdogs);
                                    localStorage.setItem("dogs.showOnlyBreedingdogs", JSON.stringify(!showOnlyBreedingdogs));
                                }}
                            >
                                { showOnlyBreedingdogs ? 
                                    <>
                                        <p>{t("dogs.showonlybreedingdogs")}</p>
                                        <i className="far fa-check-square"></i>
                                    </>
                                :
                                    <>
                                        <p>{t("dogs.showonlybreedingdogs")}</p>
                                        <i className="far fa-square"></i>
                                    </>
                                }
                            </div>
                        </div>
                        <div>
                            <div
                                className={styles.specialfiltersbtn}
                                onClick={() => {
                                    resetFilters();
                                }}
                            >
                                <p>{t("dogs.resetsearch")}</p>
                                <i className="fa fa-trash"></i>
                            </div>
                            <div
                                className={styles.specialfiltersbtn}
                                onClick={() => {
                                    setSpecialFiltersOpen(!specialFiltersOpen);
                                }}
                            >
                                <p>{t("dogs.specialfiltersbtn")}</p>
                                <i className="fa fa-filter"></i>
                            </div>
                        </div>
                        <div
                            className={styles.configurecolumnsbtn}
                            onClick={() => {
                                setShowTraitsModal(true);
                            }}
                        >
                            <p>{t("dogs.configurecolumnsbtn")}</p>
                            <i className="fa fa-cog"></i>
                        </div>
                    </div>
                }
                { specialFiltersOpen && results?.length <= 0 ?
                    <div className={styles.specialfiltersarea}>
                        <hr/>
                        <div className={styles.specialfilters}>
                            <div>
                                <h3>{t("dogs.specialfilters.fieldnameselector.title")}</h3>
                                <Field
                                    type="select"
                                    value={{ value: specialfiltersfield, label: t("dogs.table." + availableTraits.find(i => i["COLUMNDBNAME"] == specialfiltersfield)?.NAME) }}
                                    onChange={ (val: any) => {
                                        setSpecialfiltersfield(val["value"]);
                                    }}
                                    options={{
                                        choosetext: t("dogs.specialfilters.fieldnameselector.placeholder"),
                                        // Selected subset of available traits
                                        choices: [
                                            ...availableTraits.filter(i => i.LINEARFILTERING == 1).map((trait: any) => {
                                                return {
                                                    value: trait["COLUMNDBNAME"],
                                                    label: t("dogs.table." + trait["NAME"])
                                                }
                                            }),
                                        ]
                                    }}
                                ></Field>
                            </div>
                            <div>
                                <h3>{t("dogs.specialfilters.fromselector.title")}</h3>
                                <input
                                    type="text"
                                    id="specialfilters.fromselector"
                                    placeholder={t("dogs.specialfilters.fromselector.placeholder")}
                                    value={specialfiltersfrom}
                                    onChange={(e) => {
                                        setSpecialfiltersfrom(e.target.value);
                                    }}
                                />
                            </div>
                            <div>
                                <h3>{t("dogs.specialfilters.toselector.title")}</h3>
                                <input
                                    type="text"
                                    id="specialfilters.toselector"
                                    placeholder={t("dogs.specialfilters.toselector.placeholder")}
                                    value={specialfiltersto}
                                    onChange={(e) => {
                                        setSpecialfiltersto(e.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.addfilterbtncontainer}>
                                <div
                                    className={
                                        styles.button + " " +
                                        styles.addfilterbtn + " " +
                                        (specialfiltersfield == "" || (specialfiltersfrom == "" && specialfiltersto == "") ?
                                            styles.disabled
                                        : "")
                                    }
                                    onClick={() => {
                                        if (specialfiltersfield == "" || (specialfiltersfrom == "" && specialfiltersto == "")) {
                                            return;
                                        }
                                        if (specialfilters == undefined) {
                                            setSpecialfilters([{
                                                field: specialfiltersfield,
                                                type: "between",
                                                value: specialfiltersfrom + " - " + specialfiltersto
                                            }]);
                                        } else {
                                            setSpecialfilters([...specialfilters, {
                                                field: specialfiltersfield,
                                                type: "between",
                                                value: specialfiltersfrom + " - " + specialfiltersto
                                            }]);
                                        }
                                        setSpecialfiltersfield("");
                                        setSpecialfiltersfrom("");
                                        setSpecialfiltersto("");
                                    }}
                                >{t("dogs.specialfilters.addfilterbtn")}</div>
                            </div>
                        </div>
                        <div className={styles.specialfilterslist}>
                            { specialfilters != undefined && specialfilters.length > 0 ?
                                specialfilters.map((filter: any, key: any) => {
                                    return (
                                        <div key={key} className={styles.specialfilter}>
                                            <div className={styles.specialfiltername}>
                                                {t("dogs.table." + availableTraits.find(i => i["COLUMNDBNAME"] == filter["field"])?.NAME)} {t("dogs.specialfilters." + filter["type"])} {filter["value"]}
                                            </div>
                                            <div
                                                className={styles.specialfilterremove}
                                                onClick={() => {
                                                    setSpecialfilters(specialfilters.filter(i => i != filter));
                                                }}
                                            >
                                                <i className="fa fa-times"></i>
                                            </div>
                                        </div>
                                    );
                                })
                            : null }
                        </div>
                        <hr/>
                    </div>
                : <div>
                    <hr/>
                    <div className={styles.specialfiltersapplied}>
                        { specialfilters != undefined && specialfilters.length > 0 ?
                            specialfilters.map((filter: any, key: any) => {
                                return (
                                    <div className={styles.specialfilter} key={key}>
                                        <div className={styles.specialfiltername}>
                                            {t("dogs.table." + availableTraits.find(i => i["COLUMNDBNAME"] == filter["field"])?.NAME)} {t("dogs.specialfilters." + filter["type"])} {filter["value"]}
                                        </div>
                                        <div
                                            className={styles.specialfilterremove}
                                            onClick={() => {
                                                setSpecialfilters(specialfilters.filter(i => i != filter));
                                            }}
                                        >
                                            <i className="fa fa-times"></i>
                                        </div>
                                    </div>
                                );
                            })
                        : null }
                    </div>
                </div> }
                { results?.length > 0 ?
                    <div className={styles.results}>
                        <h2>{t("breedsimulator.results.title")}</h2>
                        <OffspringDisplay
                            results={results}
                            selectedDog={selectedDog}
                        ></OffspringDisplay>
                    </div>
                :
                    selectedDog != undefined ?
                        <>
                            <p><strong>{t("dogs.totalcounttext")}</strong> {totalDogs !== undefined ? totalDogs : t("dogs.loadingtotalcount")}</p>
                            <PageTable
                                loading={loading}
                                dataUrl="/api/dogs/getAllPaged"
                                onLineClick={(dataLine: any) => {
                                    // If selectedDogs does not contain the clicked dog, add it
                                    if (selectedDogs.find((dog: any) => dog["ANIMAL_ID"] == dataLine["ANIMAL_ID"]) == undefined) {
                                        setSelectedDogs([...selectedDogs, dataLine]);
                                    } else {
                                        // If selectedDogs contains the clicked dog, remove it
                                        setSelectedDogs(selectedDogs.filter((dog: any) => dog["ANIMAL_ID"] != dataLine["ANIMAL_ID"]));
                                    }
                                }}
                                dataBefore={(dataLine: any) => {
                                    // if dataLine is in selectedDogs, render a checkmark with circle else render empty circle
                                    return selectedDogs.find((dog: any) => dog["ANIMAL_ID"] == dataLine["ANIMAL_ID"]) != undefined ?
                                        <i className="far fa-check-circle"></i>
                                    :
                                        <i className="far fa-circle"></i>
                                }}
                                options={{
                                    showFields: [
                                        ...createSelectedTraitColumns(),
                                    ],
                                }}
                                onDataFetchStarted={() => {
                                    setTotalDogs(undefined);
                                }}
                                onDataFetched={(data: any) => {
                                    setTotalDogs(data["totalcount"]);
                                }}
                                selectedTraits={selectedTraits}
                                showOnlyBreedingdogs={showOnlyBreedingdogs}
                                showOnlyApproveddogs={showOnlyApproveddogs}
                                resetFilters={resetFiltersTrigger}
                                additionalData={{
                                    currentAnimalId: selectedDog?.ANIMAL_ID
                                }}
                                permaFilters={[
                                    {
                                        field: "BREED",
                                        exact: false,
                                        type: "and",
                                        values: [auth.selectedBreed?.toString() || ""]
                                    },
                                    {
                                        field: "SEX",
                                        exact: true,
                                        type: "and",
                                        values: [
                                            selectedDog?.SEX == "male" ? "female" : "male"
                                        ]
                                    },
                                    ...(specialfilters != undefined && specialfilters.length > 0 ?
                                        specialfilters.map((filter: any) => {
                                            return {
                                                field: filter["field"],
                                                exact: false,
                                                type: "between",
                                                values: [filter["value"]]
                                            }
                                        }
                                    ) : []),
                                ].filter(i => i != null)}
                                defaultSortDirection="desc"
                                defaultSortField="ANIMAL_ID"
                                hidePagination={false}
                                hidePagesize={false}
                                hideFilter={false}
                            />
                        </>
                    : 
                        <p>{t("breedsimulator.loadingdog")}</p>
                }
                <hr/>
                {/* <button className="btn btn-primary" onClick={() => {

                }}>{t("breedsimulator.buttons.startbreeding")}</button> */}
            </div>
            <Modal
                show={showTraitsModal}
                onClose={() => setShowTraitsModal(false)}
                title={t("dogs.availabletraits.title")}
            >
                <div
                    className={styles.availabletraitslist}
                >
                    <div className={styles.colheaders}>
                        <div className={styles.colheader}>
                            {t("dogs.availabletraits.colheader.name")}
                        </div>
                        <div className={styles.colheader}>
                            {t("dogs.availabletraits.colheader.selected")}
                        </div>
                    </div>
                    { availableTraits.filter(trait => !trait["COLUMNDBNAME"].includes("PCI_5GEN_WITH")).map((trait: any) => {
                        return (
                            <div
                                key={trait["ID"]}
                                className={styles.trait}
                                onClick={() => {
                                    if (selectedTraits.includes(trait["COLUMNDBNAME"])) {
                                        setSelectedTraits(selectedTraits.filter(i => i != trait["COLUMNDBNAME"]));
                                        localStorage.setItem("dogs.selectedTraits." + auth.selectedBreed, JSON.stringify(selectedTraits.filter(i => i != trait["COLUMNDBNAME"])));
                                    } else {
                                        setSelectedTraits([...selectedTraits, trait["COLUMNDBNAME"]]);
                                        localStorage.setItem("dogs.selectedTraits." + auth.selectedBreed, JSON.stringify([...selectedTraits, trait["COLUMNDBNAME"]]));
                                    }
                                }}
                            >
                                <div className={styles.traitname}>
                                    {t("dogs.table." + trait["NAME"])}
                                </div>
                                <div className={styles.traitselected}>
                                    {selectedTraits.includes(trait["COLUMNDBNAME"]) ? <i className="fa fa-check"></i> : null}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </Modal>
        </div>
    );
}

class BreedsimulatorProps {
    
}

export default Breedsimulator;